import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import Webcam from 'react-webcam';
import { Box, DialogContent } from '@mui/material';
import { IoIosCloseCircle } from "react-icons/io";


const videoConstraints = {
    width: 640,
    height: 480,
    facingMode: "user"
};

export default function CaptureDialog(props) {

    const webcamRef = React.useRef(null);
    const capture = React.useCallback(
        () => {
            const imageSrc = webcamRef.current.getScreenshot();
            props.handleCapture(imageSrc);
        },
        [webcamRef]
    );


    return (
        <React.Fragment>


            <Dialog
                open={props.open}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"

                fullWidth
            >

                <DialogContent sx={{ padding: 0 }}>


                    <Box sx={{ position: "absolute", top: 5, right: 5, cursor: "pointer", fontSize: "24px", color: "#fff" ,zIndex:10}} onClick={props.handleClose} >
                        <IoIosCloseCircle />
                    </Box>


                    <DialogContentText sx={{ overflow: "hidden" }} id="alert-dialog-description">
                        <Webcam
                            audio={false}
                            height={480}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            width={640}
                            videoConstraints={videoConstraints}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'center', paddingBottom: '20px' }}>
                    <Button 
                    variant='contained'
                    disabled={props.isLoading}
                     sx={{
                        
                        borderRadius: '5px',
                        backgroundColor: "#688B2A",
                        '&:hover': {
                            backgroundColor: "#557022", // darker shade for hover
                        }
                    }} onClick={() => capture()}>{props.isLoading?"Loading...":"capture"}</Button>

                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
